module.exports = __webpack_public_path__ + "static/media/project5.18824597.jpg";